export default {
    type: 'podcasts',
    aliases: {
        camel: 'podcasts',
        singular: 'Podcasts',
        plural: 'Podcasts',
        lowerSingular: 'podcasts',
        lowerPlural: 'podcasts',
    },
    relations: {
        'modules': {
            pivot: {
                type: 'podcast-modules',
                localKey: 'podcastId',
                foreignKey: 'moduleId'
            }
        },
        'people': {
            adminLabel: "People",
            pivot: {
                type: 'person-podcasts',
                localKey: 'podcastId',
                foreignKey: 'personId'
            }
        },
    },
    publishable: true,
    adminSection: 'news-and-views',
    componentType: 'base',
    filterOn: {
        'other': ['isPublished'],
    },
    components: {
        adminCollection: {
            name: 'AdministerPublishableCollection',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollection')
        },
        adminCollectionItem: {
            name: 'AdministerPublishableCollectionItem',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollectionItem')
        },
        adminRecord: {
            name: 'AdministerPodcastRecord',
            loader: () => import('./AdministerPodcastRecord')
        },
        webRecord: {
            name: 'DisplayPodcastRecord',
            loader: () => import('./DisplayPodcastRecord')
        },
        webCollectionItem: {
            name: 'PodcastPoster',
            loader: () => import('./PodcastPoster')
        }
    },
};
